import { IterableElement } from 'type-fest'

import { CRYPTO_TOKENS_TICKES } from './crypto-token'
import { CRYPTO_COIN_TICKERS } from './crypto-coin'

export const CRYPTO_TICKERS = [...new Set([...CRYPTO_COIN_TICKERS, ...CRYPTO_TOKENS_TICKES])]

export const CRYPTO_TICKERS_AVAILABILITY_MAP = CRYPTO_TICKERS.reduce<Map<CryptoTicker, boolean>>(
  (map, ticker) => map.set(ticker, true),
  new Map()
)

export type CryptoTicker = IterableElement<typeof CRYPTO_TICKERS>
